import Vue from "vue";
import Vuex from "vuex";
import { data } from "@/services/data";
import { parser } from "@/services/parser";

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		ready: false,
		loading: true,
		loadingText: "Loading data...",
		songs: {},
		artists: {} 
	},
	mutations: {
		loaded (state) {
			state.ready = true;
			state.loading = false;
		},
		loadingText (state, text) {
			state.loadingText = text;
		},
		songs (state, songs) {
			state.songs = songs;
		},
		artists (state, artists) {
			state.artists = artists;
		}
	},
	actions: {
		async loadSongs (context) {

			let result = {};
      
			/* await parser.parse("data.csv");
      
			return; */

			result = await data.fetchData();

			context.commit("loadingText", "Data processing...");

			context.commit("songs", result.songs);
			context.commit("artists", result.artists);
			context.commit("loaded");
		}
	}
});
